import * as React from 'react';

function SvgWaitingApproval(props) {
  return (
    <svg
      width={127}
      height={117}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="waiting-approval_svg__a" d="M0 0h160v160H0z" />
      </defs>
      <g transform="translate(-16 -22)" fill="none" fillRule="evenodd">
        <mask id="waiting-approval_svg__b" fill="#fff">
          <use xlinkHref="#waiting-approval_svg__a" />
        </mask>
        <g mask="url(#waiting-approval_svg__b)">
          <g transform="translate(16 18)">
            <path
              d="M11.103 115.445a3.645 3.645 0 01-3.645-3.645V48.225a3.645 3.645 0 013.645-3.645h100.736a3.645 3.645 0 013.646 3.645V111.8a3.645 3.645 0 01-3.646 3.645H11.103z"
              fill="#2C312F"
            />
            <path
              d="M13.805 111.961c-1.906 0-3.45-1.472-3.45-3.287V51.351c0-1.815 1.544-3.287 3.45-3.287h95.332c1.906 0 3.45 1.472 3.45 3.287v57.323c0 1.815-1.544 3.287-3.45 3.287H13.805z"
              fill="#E2F4F2"
            />
            <rect fill="#9E9E9E" x={28} y={73} width={67} height={8} rx={4} />
            <path fill="#EEF1EF" d="M0 117.929h122.942v-4.417H0z" />
            <path
              d="M61.471 117.929H0l2.503.796c4.44 1.414 9.548 2.163 14.757 2.163h88.422c5.21 0 10.317-.749 14.758-2.163l2.502-.796h-61.47"
              fill="#C7C7C4"
            />
            <path
              d="M44.048 13.104a5.55 5.55 0 117.904 7.792 5.55 5.55 0 01-7.904-7.792zM42.879 24.49a9.013 9.013 0 003.573 1.45l.012 1.758a1.612 1.612 0 003.225-.023l-.013-1.758a9.014 9.014 0 003.55-1.5l1.253 1.233a1.612 1.612 0 002.263-2.295l-1.251-1.235a9.023 9.023 0 001.45-3.572l1.757-.013a1.612 1.612 0 00-.023-3.224l-1.758.013a9.032 9.032 0 00-1.5-3.552l1.233-1.25a1.612 1.612 0 00-2.296-2.264L53.12 9.509a9.035 9.035 0 00-3.572-1.45l-.013-1.757a1.611 1.611 0 10-3.224.023l.013 1.758a9.014 9.014 0 00-3.551 1.5L41.52 8.35a1.61 1.61 0 00-2.279.017 1.61 1.61 0 00.017 2.278l1.251 1.235a9.023 9.023 0 00-1.45 3.572l-1.757.013a1.611 1.611 0 10.023 3.224l1.758-.013a9.014 9.014 0 001.5 3.552l-1.233 1.251a1.612 1.612 0 102.295 2.264l1.234-1.253z"
              fill="#FCCE01"
            />
            <path
              d="M99.7 16.983C98.3 10.15 92.3 5 85 5c-5.8 0-10.8 3.268-13.3 8.021-6 .595-10.7 5.646-10.7 11.79 0 6.537 5.399 11.887 12 11.887h26c5.5 0 10-4.458 10-9.905.022-5.198-4.062-9.506-9.3-9.81zm-11.839 4.94v6.672H82.14v-6.671h-6.08L85 13.15l8.941 8.777-6.08-.004z"
              fill="#D1CCB7"
              fillRule="nonzero"
            />
            <path
              d="M25.935 43.277a7.892 7.892 0 01-4.2-10.341 7.893 7.893 0 1114.543 6.14 7.893 7.893 0 01-10.343 4.201zm-3.58 8.48a2.242 2.242 0 002.936-1.192l.95-2.25c1.8.405 3.624.402 5.36.036l.92 2.263a2.243 2.243 0 002.92 1.234 2.243 2.243 0 001.233-2.92l-.92-2.264c1.5-.947 2.81-2.218 3.816-3.764l2.251.95a2.24 2.24 0 101.744-4.128l-2.251-.95c.406-1.8.403-3.625.037-5.36l2.264-.92a2.242 2.242 0 00-1.688-4.153l-2.263.92a12.542 12.542 0 00-3.764-3.817l.95-2.25a2.24 2.24 0 10-4.129-1.744l-.95 2.251a12.54 12.54 0 00-5.36-.037l-.92-2.264a2.24 2.24 0 10-4.152 1.687l.92 2.264c-1.5.947-2.81 2.218-3.816 3.764l-2.252-.95a2.24 2.24 0 10-1.743 4.128l2.25.95a12.537 12.537 0 00-.036 5.36l-2.264.92a2.241 2.241 0 001.686 4.153l2.265-.92a12.54 12.54 0 003.764 3.816l-.95 2.252a2.24 2.24 0 001.192 2.936z"
              fill="#CCC8B4"
            />
            <g transform="rotate(30 1.85 131.471)">
              <path d="M1 0h43l8 8v61a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z" fill="#FFF" />
              <path
                fill="#E7E7E7"
                d="M43.171 51.496l-33.17.019L10 48.02 43.17 48l.001 3.496m0 7.897l-33.17.03L10 55.937l33.17-.029.001 3.485"
              />
              <circle fill="#38B2A6" cx={26.181} cy={26.181} r={13.181} />
              <path
                d="M19.837 25.085l5.872-5.307a.678.678 0 01.937 0l2.912 2.63v-.47c0-.171.132-.312.293-.312h.805c.16 0 .293.14.293.313v1.737l1.567 1.409a.807.807 0 01.087 1.08.688.688 0 01-1.01.094l-.087-.078v6.105c0 .265-.205.485-.454.485H27.7V27.12h-3.015v5.65h-3.353c-.248 0-.454-.219-.454-.484V26.18l-.087.078a.688.688 0 01-.469.188.736.736 0 01-.556-.266c-.264-.344-.22-.83.072-1.096"
                fill="#FFF"
              />
              <path fill="#38B2A6" d="M52.002 8h-8.003V0z" />
            </g>
            <path fill="#E2F4F2" d="M22 81h81v31H22z" />
            <path fill="#FFF8DA" d="M103.47 102.777L98.9 88.705 127 81z" />
            <path fill="#FEDD48" d="M99.214 89.646l-7.91-4.18L127 81z" />
            <path fill="#F9A600" d="M103.47 102.777l.72-9.172h10.102z" />
            <path fill="#FEDD48" d="M127 81l-12.68 23.28-10.13-10.675z" />
            <path
              d="M67.732 100.148l.728.685a1 1 0 001.37-1.457l-.728-.685a1 1 0 10-1.37 1.457zm4.35 3.012l.895.446a1 1 0 00.893-1.79l-.895-.446a1 1 0 10-.893 1.79zm4.933 1.746l.974.227a1 1 0 10.454-1.947l-.973-.228a1 1 0 00-.455 1.948zm5.156.73l.998.062a1 1 0 00.123-1.997l-.998-.061a1 1 0 10-.123 1.996zm5.073-.001l.998-.056a1 1 0 00-.111-1.997l-.999.056a1 1 0 00.112 1.997zm5.078-.515l.99-.142a1 1 0 00-.284-1.98l-.99.142a1 1 0 10.284 1.98zm5.005-.892l.979-.206a1 1 0 00-.413-1.957l-.978.206a1 1 0 10.412 1.957z"
              fill="#9E9E9E"
              fillRule="nonzero"
            />
            <g transform="translate(45 88)">
              <path
                d="M0 6.999V1.047a1 1 0 01.999-1l32-.046a1 1 0 011 1v5.957a1 1 0 01-.998 1l-32 .04a1 1 0 01-1-1z"
                fill="#F9A600"
              />
              <circle fill="#FFF" cx={9} cy={4} r={2} />
              <circle fill="#FFF" cx={17} cy={4} r={2} />
              <circle fill="#FFF" cx={25} cy={4} r={2} />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgWaitingApproval;
